export const LF_UK_STORE = "LF_UK_STORE";
